import React from "react";
import ReadingForm from "components/readingsAndAnamnesisForms/ReadingForm";
import ReadingsStore from "stores/ReadingsStore";

const ReadingFormPrimaryReadings = (props) => {
    const editingId = props.match.params.id;
    return <ReadingForm {...props} editingId={editingId} store={ReadingsStore} accessor={ReadingsStore.PRIMARY_READING_ACCESSOR} reroute={"/readings"} />;
};

export default ReadingFormPrimaryReadings;